import {FC, useState} from "react";
import {useUsersInvited} from "../../../../queries/useUsersInvited.ts";
import {Flex, Input} from "antd";
import styles from "../UsersTab/UsersTab.module.css";
import {SearchOutlined} from "@ant-design/icons";
import {InvitesTable} from "../InvitesTable/InvitesTable.tsx";
import {isFirManager, isRegionManager} from "../../../../utils/userTypeGuards.ts";

export const InvitesTab: FC = () => {
    const { data, isLoading } = useUsersInvited();
    const [filterValue, setFilterValue] = useState('');

    const filteredUsers = data?.filter((user) =>
            user.id.toString().includes(filterValue) ||
            isFirManager(user) && user.firs.some(({ id, name, region }) =>
                id.includes(filterValue) || name.includes(filterValue) || region.name.includes(filterValue)
            ) ||
            isRegionManager(user) && user.region?.name.includes(filterValue)
    ) || [];

    return (
        <Flex vertical gap={16}>
            <Flex justify="space-between">
                <Input
                    className={styles.searchInput}
                    prefix={<SearchOutlined />}
                    placeholder="Поиск"
                    value={filterValue}
                    onChange={(v) => setFilterValue(v.target.value)}
                />
            </Flex>
            <InvitesTable
                users={filteredUsers}
                loading={isLoading}
            />
        </Flex>
    )
}